
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { MapPin, Clock, Phone, Star } from "lucide-react";
import { Link } from "react-router-dom";

const Locations = () => {
  const locations = [
    {
      name: "Bespoke Dental Studios",
      address: "20111 SW Birch St Suite 245, Newport Beach, CA 92660",
      phone: "(949) 416-2026",
      hours: "Mon-Fri: 8am-6pm, Sat: 9am-4pm",
      type: "Bespoke",
      city: "Newport Beach",
      region: "Orange County",
      rating: 4.9,
      reviews: 235
    },
    {
      name: "Smile Select Dental",
      address: "2010 W Lincoln Ave, Anaheim, CA 92801",
      phone: "(714) 821-5151",
      hours: "Mon-Fri: 9am-7pm, Sat: 9am-5pm",
      type: "Smile Select",
      city: "Anaheim",
      region: "Orange County",
      rating: 4.9,
      reviews: 580
    },
    {
      name: "Smile Select Dental",
      address: "375 W Central Ave, Brea, CA 92821",
      phone: "(714) 674-8585",
      hours: "Mon-Fri: 8am-6pm, Sat: 9am-4pm",
      type: "Smile Select",
      city: "Brea",
      region: "Orange County",
      rating: 4.9,
      reviews: 487
    },
    {
      name: "Smile Select Dental",
      address: "17100 Norwalk Blvd, Cerritos, CA 90703",
      phone: "(562) 809-8808",
      hours: "Mon-Fri: 9am-7pm, Sat: 9am-5pm",
      type: "Smile Select",
      city: "Cerritos",
      region: "Orange County",
      rating: 4.9,
      reviews: 322
    },
    {
      name: "Smile Select Dental",
      address: "5807 Pine Ave, Chino Hills, CA 91709",
      phone: "(909) 606-5566",
      hours: "Mon-Fri: 8am-6pm, Sat: 9am-4pm",
      type: "Smile Select",
      city: "Chino Hills",
      region: "Inland Empire",
      rating: 4.9,
      reviews: 592
    },
    {
      name: "Smile Select Dental",
      address: "8750 19th St, Alta Loma, CA 91701",
      phone: "(909) 483-1177",
      hours: "Mon-Fri: 9am-7pm, Sat: 9am-5pm",
      type: "Smile Select",
      city: "Alta Loma",
      region: "Inland Empire",
      rating: 4.8,
      reviews: 468
    },
    {
      name: "Smile Select Dental",
      address: "2838 Hamner Ave, Norco, CA 92860",
      phone: "(951) 520-8200",
      hours: "Mon-Fri: 8am-6pm, Sat: 9am-4pm",
      type: "Smile Select",
      city: "Norco",
      region: "Inland Empire",
      rating: 4.9,
      reviews: 225
    },
    {
      name: "Smile Select Dental",
      address: "1819 E D St, Ontario, CA 91764",
      phone: "(909) 988-8888",
      hours: "Mon-Fri: 9am-7pm, Sat: 9am-5pm",
      type: "Smile Select",
      city: "Ontario",
      region: "Inland Empire",
      rating: 4.9,
      reviews: 300
    },
    {
      name: "Smile Select Dental",
      address: "1000 Indiana Ave Suite 5, Riverside, CA 92506",
      phone: "(951) 684-3100",
      hours: "Mon-Fri: 8am-6pm, Sat: 9am-4pm",
      type: "Smile Select",
      city: "Riverside",
      region: "Inland Empire",
      rating: 4.8,
      reviews: 440
    },
    {
      name: "Smile Select Dental",
      address: "1050 Lakes Dr #140, West Covina, CA 91790",
      phone: "(626) 653-9560",
      hours: "Mon-Fri: 9am-7pm, Sat: 9am-5pm",
      type: "Smile Select",
      city: "West Covina",
      region: "San Gabriel Valley",
      rating: 4.9,
      reviews: 334
    },
    {
      name: "Smile Select Dental",
      address: "20855 Golden Springs Dr #108, Diamond Bar, CA 91789",
      phone: "(909) 598-1122",
      hours: "Mon-Fri: 8am-6pm, Sat: 9am-4pm",
      type: "Smile Select",
      city: "Diamond Bar",
      region: "San Gabriel Valley",
      rating: 4.9,
      reviews: 64
    },
    {
      name: "Smile Select Dental",
      address: "210 S Grand Ave Suite 208, Glendora, CA 91741",
      phone: "(626) 963-9999",
      hours: "Mon-Fri: 9am-7pm, Sat: 9am-5pm",
      type: "Smile Select",
      city: "Glendora",
      region: "San Gabriel Valley",
      rating: 4.9,
      reviews: 225
    },
    {
      name: "Smile Select Dental",
      address: "555 N 13th Ave, Upland, CA 91786",
      phone: "(909) 982-0880",
      hours: "Mon-Fri: 8am-6pm, Sat: 9am-4pm",
      type: "Smile Select",
      city: "Upland",
      region: "San Gabriel Valley",
      rating: 4.9,
      reviews: 288
    },
    {
      name: "Smile Select Dental",
      address: "40963 Winchester Rd, Murrieta, CA 92563",
      phone: "(951) 698-4444",
      hours: "Mon-Fri: 9am-7pm, Sat: 9am-5pm",
      type: "Smile Select",
      city: "Murrieta",
      region: "Inland Empire",
      rating: 4.8,
      reviews: 190
    }
  ];

  // Group locations by region
  const locationsByRegion = locations.reduce((acc, location) => {
    if (!acc[location.region]) {
      acc[location.region] = [];
    }
    acc[location.region].push(location);
    return acc;
  }, {} as Record<string, typeof locations>);

  return (
    <Layout>
      {/* Hero Section */}
      <section className="py-20" style={{ background: 'linear-gradient(135deg, #FAF8F6, #F2D9D3)' }}>
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 font-juv-heading" style={{ color: '#5C322B' }}>
              Visit One of Our Luxury Studios
            </h1>
            <p className="text-xl leading-relaxed font-juv-body mb-8" style={{ color: '#5C322B' }}>
              JUV is available inside trusted partner clinics across Southern California. Experience premium care powered by JUV-trained teams, licensed injectors, and advanced technology.
            </p>
          </div>
        </div>
      </section>

      {/* Map Placeholder */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-6">
          <div className="h-96 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(242, 217, 211, 0.3)', borderColor: 'rgba(205, 167, 157, 0.3)' }}>
            <div className="text-center">
              <MapPin className="h-12 w-12 mx-auto mb-4" style={{ color: '#A55C52' }} />
              <h3 className="text-xl font-semibold mb-2" style={{ color: '#5C322B' }}>Interactive Map Coming Soon</h3>
              <p style={{ color: 'rgba(92, 50, 43, 0.7)' }}>Explore our locations with custom rose clay pins and region clustering</p>
            </div>
          </div>
        </div>
      </section>

      {/* Locations Grid */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          {Object.entries(locationsByRegion).map(([region, regionLocations]) => (
            <div key={region} className="mb-16">
              <h2 className="text-3xl font-bold mb-8 font-juv-heading text-center" style={{ color: '#5C322B' }}>
                {region}
              </h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {regionLocations.map((location, index) => (
                  <Card 
                    key={index} 
                    className="group hover:shadow-glow transition-all duration-300 hover:scale-105 bg-white"
                    style={{ borderColor: 'rgba(205, 167, 157, 0.3)' }}
                  >
                    {/* Location Image with Arch Top */}
                    <div className="relative overflow-hidden rounded-t-2xl h-48" style={{ backgroundColor: 'rgba(242, 217, 211, 0.3)' }}>
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="text-6xl opacity-30">🏢</div>
                      </div>
                      <div className={`absolute top-4 left-4 inline-block px-3 py-1 rounded-full text-xs font-semibold text-white`}
                           style={{ backgroundColor: location.type === 'Bespoke' ? '#A55C52' : '#CDA79D' }}>
                        {location.type}
                      </div>
                    </div>
                    
                    <CardContent className="p-6">
                      <div className="flex items-center justify-between mb-2">
                        <h3 className="text-xl font-bold font-juv-heading" style={{ color: '#5C322B' }}>
                          {location.name}
                        </h3>
                        <div className="flex items-center space-x-1">
                          <Star className="h-4 w-4 fill-current" style={{ color: '#A55C52' }} />
                          <span className="text-sm font-medium" style={{ color: '#5C322B' }}>
                            {location.rating} ({location.reviews})
                          </span>
                        </div>
                      </div>
                      
                      <div className="space-y-3 mb-6">
                        <div className="flex items-start gap-3">
                          <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: '#A55C52' }} />
                          <p className="font-juv-body text-sm" style={{ color: '#5C322B' }}>
                            {location.address}
                          </p>
                        </div>
                        
                        <div className="flex items-center gap-3">
                          <Phone className="w-5 h-5 flex-shrink-0" style={{ color: '#A55C52' }} />
                          <p className="font-juv-body text-sm" style={{ color: '#5C322B' }}>
                            {location.phone}
                          </p>
                        </div>
                        
                        <div className="flex items-start gap-3">
                          <Clock className="w-5 h-5 mt-0.5 flex-shrink-0" style={{ color: '#A55C52' }} />
                          <p className="font-juv-body text-sm" style={{ color: '#5C322B' }}>
                            {location.hours}
                          </p>
                        </div>
                      </div>
                      
                      <div className="flex gap-2">
                        <Button 
                          asChild 
                          variant="outline"
                          className="flex-1 hover:bg-white/80"
                          style={{ borderColor: 'rgba(205, 167, 157, 0.5)', color: '#5C322B' }}
                        >
                          <Link to={`/locations/${location.city.toLowerCase().replace(' ', '-')}`}>
                            Directions
                          </Link>
                        </Button>
                        <Button 
                          asChild
                          className="flex-1 text-white hover:opacity-90"
                          style={{ backgroundColor: '#A55C52' }}
                        >
                          <Link to="/quiz">
                            Book Now
                          </Link>
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16" style={{ background: 'linear-gradient(135deg, #FAF8F6, #F2D9D3)' }}>
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-6 font-juv-heading" style={{ color: '#5C322B' }}>
            Ready to Start Your JUV Journey?
          </h2>
          <p className="text-xl mb-8 font-juv-body max-w-2xl mx-auto" style={{ color: '#5C322B' }}>
            Book your consultation at any of our locations and discover the JUV difference.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              asChild
              size="lg" 
              className="text-white px-8 py-4 hover:opacity-90"
              style={{ backgroundColor: '#A55C52' }}
            >
              <Link to="/quiz">Take the Quiz</Link>
            </Button>
            <Button 
              asChild
              size="lg" 
              variant="outline"
              className="px-8 py-4 hover:bg-white/80"
              style={{ borderColor: 'rgba(205, 167, 157, 0.5)', color: '#5C322B' }}
            >
              <Link to="/treatments">View All Treatments</Link>
            </Button>
          </div>
        </div>
      </section>

      {/* Sticky CTA Bar */}
      <div className="fixed bottom-0 left-0 right-0 p-4 text-white z-50" style={{ background: 'linear-gradient(to right, #A55C52, #5C322B)' }}>
        <div className="container mx-auto flex items-center justify-between">
          <div>
            <p className="font-semibold">Ready to start your JUV journey?</p>
          </div>
          <div className="flex gap-3">
            <Button 
              asChild
              variant="secondary"
              className="bg-white hover:bg-white/90"
              style={{ color: '#5C322B' }}
            >
              <Link to="/quiz">Book a Consultation</Link>
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-white text-white hover:bg-white/10"
            >
              <a href="tel:1-800-JUV-GLOW">Call 1-800-JUV-GLOW</a>
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Locations;
